var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', [_c('b-row', {
    staticClass: "custom-search align-items-center justify-content-end mb-1"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "6",
      "lg": "4"
    }
  }, [_vm.$permissionAbility(_vm.OUTREACH_AUTHOR_SHOW, _vm.permissions) ? _c('b-form-input', {
    staticClass: "mb-2 mb-sm-0",
    attrs: {
      "placeholder": "Search...",
      "type": "text"
    },
    on: {
      "keyup": _vm.onSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function callback($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }) : _vm._e()], 1), _c('b-col', {
    staticClass: "text-sm-right",
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_vm.$permissionAbility(_vm.OUTREACH_AUTHOR_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 w-100 w-sm-auto",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showCreateModal
    }
  }, [_vm._v(" Create ")])] : _vm._e()], 2)], 1), _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_SHOW, _vm.permissions) ? _c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table table-custom-style striped clickable-rows",
      "line-numbers": false,
      "mode": "remote",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "columns": _vm.columns,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'created_at',
          type: 'desc'
        }]
      },
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange,
      "on-row-click": _vm.onRowClick,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$row, _props$row2, _props$column2, _props$row3, _props$row4, _props$column3, _props$row5, _props$row6, _props$row7;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_status' ? [_c('b-badge', {
          attrs: {
            "variant": _vm.statusVariant(props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.status)
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.status) + " ")])] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_contact' ? [props !== null && props !== void 0 && (_props$row3 = props.row) !== null && _props$row3 !== void 0 && _props$row3.contact ? _c('div', [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : _props$row4.contact))])]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-warning"
          }
        }, [_vm._v("NA")])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) === 'format_posts' ? [_c('span', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row5 = props.row) === null || _props$row5 === void 0 ? void 0 : _props$row5.posts_used) + " / " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : _props$row6.total_posts_approved))])] : _vm._e(), props.column.field === 'action' ? _c('span', [(props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : _props$row7.status) === 'pending' && _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_REVIEW, _vm.permissions) ? [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": "Approve"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.onStatusChange(props.row, 'approved');
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50 custom-icon cursor-pointer text-success",
          attrs: {
            "icon": "CheckCircleIcon",
            "size": "16"
          }
        })], 1), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": "Reject"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.onStatusChange(props.row, 'rejected');
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50 custom-icon cursor-pointer text-danger",
          attrs: {
            "icon": "XCircleIcon",
            "size": "16"
          }
        })], 1)] : _vm._e(), _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_SHOW, _vm.permissions) ? [_c('span', {
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.viewDetail(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "EyeIcon",
            "title": "View Detail",
            "size": "16"
          }
        })], 1)] : _vm._e(), _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_EDIT, _vm.permissions) ? [_c('span', {
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.onEdit(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "Edit2Icon",
            "title": "Edit",
            "size": "16"
          }
        })], 1)] : _vm._e(), _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_DELETE, _vm.permissions) ? [_c('span', {
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.onDelete(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "TrashIcon",
            "title": "Delete",
            "size": "16"
          }
        })], 1)] : _vm._e()], 2) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }], null, false, 2644164373)
  }) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "modal-author-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Edit Author' : 'Create Author',
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "authorValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Name",
      "label-for": "name"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Author Name",
      "vid": "name",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Author Name"
          },
          model: {
            value: _vm.authorName,
            callback: function callback($$v) {
              _vm.authorName = $$v;
            },
            expression: "authorName"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Contact / Handle",
      "label-for": "contact"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Contact",
      "vid": "contact",
      "rules": "max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "contact",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Email, Skype, or handle"
          },
          model: {
            value: _vm.authorContact,
            callback: function callback($$v) {
              _vm.authorContact = $$v;
            },
            expression: "authorContact"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Websites",
      "label-for": "websites"
    }
  }, [_vm._l(_vm.authorWebsites, function (site, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2 p-2 border rounded"
    }, [_c('b-form-group', {
      staticClass: "mb-1",
      attrs: {
        "label": "URL"
      }
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('b-form-input', {
      staticClass: "mr-1",
      attrs: {
        "placeholder": "https://example.com",
        "type": "url"
      },
      model: {
        value: site.url,
        callback: function callback($$v) {
          _vm.$set(site, "url", $$v);
        },
        expression: "site.url"
      }
    }), _vm.authorWebsites.length > 1 ? _c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.removeWebsite(index);
        }
      }
    }, [_c('feather-icon', {
      attrs: {
        "icon": "XIcon"
      }
    })], 1) : _vm._e()], 1)]), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "3",
        "sm": "6",
        "cols": "12"
      }
    }, [_c('b-form-group', {
      staticClass: "mb-1",
      attrs: {
        "label": "Domain Authority"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "placeholder": "Domain Authority",
        "size": "sm"
      },
      model: {
        value: site.domain_authority,
        callback: function callback($$v) {
          _vm.$set(site, "domain_authority", $$v);
        },
        expression: "site.domain_authority"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "3",
        "sm": "6",
        "cols": "12"
      }
    }, [_c('b-form-group', {
      staticClass: "mb-1",
      attrs: {
        "label": "Traffic"
      }
    }, [_c('b-form-input', {
      attrs: {
        "placeholder": "Traffic",
        "size": "sm"
      },
      model: {
        value: site.traffic,
        callback: function callback($$v) {
          _vm.$set(site, "traffic", $$v);
        },
        expression: "site.traffic"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "3",
        "sm": "6",
        "cols": "12"
      }
    }, [_c('b-form-group', {
      staticClass: "mb-1",
      attrs: {
        "label": "Traffic Value ($)"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": "Traffic Value",
        "size": "sm"
      },
      model: {
        value: site.traffic_value,
        callback: function callback($$v) {
          _vm.$set(site, "traffic_value", $$v);
        },
        expression: "site.traffic_value"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "3",
        "sm": "6",
        "cols": "12"
      }
    }, [_c('b-form-group', {
      staticClass: "mb-1",
      attrs: {
        "label": "Spam Score (%)"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "placeholder": "Spam Score",
        "min": "0",
        "max": "100",
        "size": "sm"
      },
      model: {
        value: site.spam_score,
        callback: function callback($$v) {
          _vm.$set(site, "spam_score", $$v);
        },
        expression: "site.spam_score"
      }
    })], 1)], 1)], 1)], 1);
  }), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": _vm.addWebsite
    }
  }, [_vm._v(" + Add Website ")])], 2), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Approved For Niche",
      "label-for": "niches"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Niches",
      "vid": "niches",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('v-select', {
          attrs: {
            "options": _vm.nicheOptions,
            "label": "name",
            "reduce": function reduce(item) {
              return item.id;
            },
            "multiple": "",
            "placeholder": "Select niches"
          },
          model: {
            value: _vm.authorNiches,
            callback: function callback($$v) {
              _vm.authorNiches = $$v;
            },
            expression: "authorNiches"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Notes",
      "label-for": "notes"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "notes",
      "placeholder": "Internal notes",
      "rows": "3"
    },
    model: {
      value: _vm.authorNotes,
      callback: function callback($$v) {
        _vm.authorNotes = $$v;
      },
      expression: "authorNotes"
    }
  })], 1), _vm.isSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }